import styled from 'styled-components';

import Button, { ButtonProps } from 'components/shared/Button';
import CircularProgress from 'components/shared/CircularProgress';
import useAsyncExport from 'hooks/useAsyncExport';
import JobProcess from 'models/JobProcess';
import colors from 'styles/theme/colors';

type DownloadAIExportButtonProps = ButtonProps & {
  label: string;
  onExport: () => Promise<JobProcess>;
};

export function DownloadAIExportButton({ label, onExport, ...rest }: DownloadAIExportButtonProps) {
  const { exporting, initiateExport } = useAsyncExport(onExport);

  return (
    <StyledButton variant='outline-primary' {...rest} onClick={() => initiateExport()} disabled={exporting}>
      <span style={{ opacity: exporting ? 0 : 1 }}>{label}</span>
      {exporting && (
        <SpinnerContainer>
          <ExportLoadingIndicator thickness={2} />
        </SpinnerContainer>
      )}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  font-size: 12px;
  padding: 8px 16px;
  position: relative;
`;

const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ExportLoadingIndicator = styled(CircularProgress)`
  width: 18px;
  height: 18px;
  color: ${colors.blue100};
`;
